export default __webpack_public_path__ + "static/IN-8015HD_Quick-Installation_P2P-WPS_08-2998609145177bf7d7da68b7b38dfa95.webp";